/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 站点管理列表
  sitesList: `${prefix}/sites/tree`,
  // 可管理站点列表
  sitesOwnsite: `${prefix}/sites/ownsite`,
  // 模板管理列表
  templateList: `${prefix}/template/list`,
  // 模板管理文件树结构
  templateTree: `${prefix}/template/tree`,
  // 模板管理添加目录
  templateDir: `${prefix}/template/dir`,
  // 模板管理模板修改
  template: `${prefix}/template`,
  // 模板管理上传模板
  templateUpload: `${prefix}/template/upload`,
  // 模板管理导入文件
  templateImport: `${prefix}/template/import`,
  // 模板管理导出文件
  templateExport: `${prefix}/template/export`,
  // 模板管理获取模型列表
  templateModelList: `${prefix}/model/list`,
  // 模板管理检验文件夹名称
  templateUniqueDirName: `${prefix}/template/unique/dirName`,
  // 模板管理检验模板方案名称
  templateUniqueName: `${prefix}/template/unique/name`,
  // 文件管理新增目录
  resourceDir: `${prefix}/resource/dir`,
  // 文件管理
  resource: `${prefix}/resource`,
  // 文件管理列表
  resourceList: `${prefix}/resource/list`,
  // 文件管理文件树结构
  resourceTree: `${prefix}/resource/tree`,
  // 文件管理文件上传
  resourceUpload: `${prefix}/resource/upload`,
  // 文件管理文件上传
  resourceUniqueDir: `${prefix}/resource/unique/dir`,
  // 站点管理站点扩展配置
  sitesExt: `${prefix}/sites/ext`,
  // 站点管理站点基本信息
  sites: `${prefix}/sites`,
  // 站点管理站点模板设置
  sitesModel: `${prefix}/sites/model`,
  // 站点管理站点模板方案列表
  sitesSolutions: `${prefix}/sites/solutions`,
  // 站点管理站点首页模板列表
  sitesTplList: `${prefix}/sites/tpl/list`,
  // 站点管理验证域名
  sitesDomainUnique: `${prefix}/sites/domain/unique`,
  // 站点管理验证目录
  sitesPathUnique: `${prefix}/sites/path/unique`,
  // 站点管理上级站点联级选择器
  sitesChilds: `${prefix}/sites/childs`,
  // 站点管理站点回收站
  sitesRecycle: `${prefix}/sites/recycle`,
  // 站点管理站点回收站还原
  sitesRestore: `${prefix}/sites/restore`,
  // 站点管理站点模板列表
  sitesModels: `${prefix}/sites/models`,
  // 站点-开启站点
  sitesOn: `${prefix}/sites/on`,
  // 站点-关闭站点
  sitesOff: `${prefix}/sites/off`,
  // 站点排序
  sitesSort: `${prefix}/sites/sort`,
  // 站点管理-表态化-栏目-进度
  staticChannelProgress: `${prefix}/content/staticPage/channel/process`,
  // 站点管理-表态化-内容-进度
  staticContentProgress: `${prefix}/content/staticPage/content/process`,
  // 站点管理查询可静态化栏目树
  staticChannelTree: `${prefix}/channel/staticChannelTree`,
  // 站点管理查询可发布内容化栏目树
  publicContentChannelTree: `${prefix}/channel/publicContentChannelTree`,
  // 站点管理发布静态页发布首页
  staticPageIndex: `${prefix}/content/staticPage/index`,
  // 站点管理发布静态页栏目静态化
  sitesChannelBatch: `${prefix}/content/staticPage/channelBatch`,
  // 站点管理发布静态页删除栏目静态化
  sitesChannel: `${prefix}/content/staticPage/channel`,
  // 站点管理发布静态页内容静态化
  sitesContentBatch: `${prefix}/content/staticPage/contentBatch`,
  // 站点管理发布静态页删除内容静态化
  sitesContent: `${prefix}/content/staticPage/content`,
  // 站点-权限-组织及角色
  sitesPermOrg: `${prefix}/dataPerm/site/org`,
  // 站点-权限-用户
  sitesPermUser: `${prefix}/dataPerm/site/user`,
  // 站群-权限-组织及角色
  sitesGroupPermOrg: `${prefix}/dataPerm/ownerSite/org`,
  // 站群-权限-用户
  sitesGroupPermUser: `${prefix}/dataPerm/ownerSite/user`,
  // 消息管理-分页列表
  messageTplPage: `${prefix}/messageTpl/page`,
  // 消息管理-短信模板集合
  messageTplPhoneListPage: `${prefix}/messageTpl/phone/tpl/list `,
  // 消息管理-分页列表
  messageDetailsStatus: `${prefix}/messageTpl/details/status`,
  // 消息管理-是否显示隐藏同步子站按钮
  messageSynchBut: `${prefix}/messageTpl/synch/button`,
  // 消息管理-同步子站点列表 /sites/getAllTree
  messaggetAllTree: `${prefix}/sites/getAllTree`,
  // 消息管理-同步保存
  messaggetSynchChild: `${prefix}/messageTpl/synch/child/site/tpl`,
  // 判断是否有余量
  messaggetHaveNumber: `${prefix}/messageTpl/have/number`,
  // 消息管理-详情
  messageTpl: `${prefix}/messageTpl`,
  // 消息管理-校验模板标识是否可用-是否重复
  messageTplMesCodeUnique: `${prefix}/messageTpl/mesCode/unique`,
  // 敏感词-列表
  sensitiveWordsPage: `${prefix}/sensitiveWords/page`,
  // 敏感词-添加,修改，删除
  sensitiveWords: `${prefix}/sensitiveWords`,
  // 敏感词-导入
  sensitiveWordsImport: `${prefix}/sensitiveWords/import`,
  // 敏感词-重名
  sensitiveWordsUnique: `${prefix}/sensitiveWords/unique`,
  // 敏感词-下载模板
  sensitiveWordsDownload: `${prefix}/sensitiveWords/download`,
  // 搜索词-分页
  sysSearchWordsPage: `${prefix}/searchWords/page`,
  // 搜索词-添加，修改，删除
  sysSearchWords: `${prefix}/searchWords`,
  // 搜索词-重名
  sysSearchWordsUnique: `${prefix}/searchWords/unique/word`,
  // 热词-分页
  hotWordCategorysPage: `${prefix}/hotWordCategorys/page`,
  // 热词-列表
  hotWordCategorysList: `${prefix}/hotWordCategorys/list`,
  // 热词-新增，删除，修改
  hotWordCategorys: `${prefix}/hotWordCategorys`,
  // 热词-重名
  hotWordCategorysCateNameUnique: `${prefix}/hotWordCategorys/cateName/unique`,
  // 热词管理-列表
  hotWordsPage: `${prefix}/hotWords/page`,
  // 热词管理-新增，删除，修改
  hotWords: `${prefix}/hotWords`,
  // 热词管理-列表
  hotWordsUnique: `${prefix}/hotWords/unique/hotWord`,
  // 内容类型-列表
  contentTypePage: `${prefix}/contentType/page`,
  // 内容类型-添加，删除，修改
  contentType: `${prefix}/contentType`,
  // 内容类型-重名
  contentTypeUnique: `${prefix}/contentType/typeName/unique`,
  // 发文字号-机关代字-列表
  contentMarksAgencyPage: `${prefix}/contentMarks/agency/page`,
  // 发文字号-机关代字-新增，修改，删除
  contentMarksAgency: `${prefix}/contentMarks/agency`,
  // 发文字号-机关代字-排序
  contentMarksAgencySort: `${prefix}/contentMarks/agency/sort`,
  // 发文字号-机关代字-排序
  contentMarksAgencyUnique: `${prefix}/contentMarks/agency/unique`,
  // 发文字号-年号-重名
  contentMarksYearPage: `${prefix}/contentMarks/year/page`,
  // 发文字号-年号-新增，修改，删除
  contentMarksYear: `${prefix}/contentMarks/year`,
  // 发文字号-年号-排序
  contentMarksYearSort: `${prefix}/contentMarks/year/sort`,
  // 发文字号-年号-重名
  contentMarksYearUnique: `${prefix}/contentMarks/year/unique`,
  // 定时任务-列表
  jobsPage: `${prefix}/jobs/page`,
  // 定时任务-增删改查
  jobs: `${prefix}/jobs`,
  // 定时任务-状态取消
  jobsDisabledJobs: `${prefix}/jobs/disabledJobs`,
  // 定时任务-状态启用
  jobsEnabledJobs: `${prefix}/jobs/enabledJobs`,
  // 定时任务-校验任务名称
  jobsUnique: `${prefix}/jobs/jobName/unique`,
  // tag-列表
  contentTagsPage: `${prefix}/contentTags/page`,
  // tag-新增，修改，删除
  contentTags: `${prefix}/contentTags`,
  // tag-重名
  contentTagsUnique: `${prefix}/contentTags/tagName/unique`,
  // 内容索引-列表

  // 内容索引-重置
  contentResetIndex: `${prefix}/content/resetIndex`,
  // 内容索引-索引开关
  channelSetOpenIndex: `${prefix}/channel/setOpenIndex`,
  // 来源管理-列表
  sysSourcePage: `${prefix}/sysSource/page`,
  // 来源管理-新增，修改，删除
  sysSource: `${prefix}/sysSource`,
  // 来源管理-重名
  sysSourceUnique: `${prefix}/sysSource/sourceName/unique`,
  // 站点树
  sitesGetOwnerTree: `${prefix}/sites/getOwnerTree`,
  // 工作流分页
  flowPage: `${prefix}/workflow/page`,
  // 工作流列表
  flowList: `${prefix}/workflow/list`,
  // 工作流
  flow: `${prefix}/workflow`,
  // 工作流检查
  flowCheck: `${prefix}/workflow/validateRule`,
  // 工作流名称查重
  flowUnique: `${prefix}/workflow/exist`,
  // 审核策略管理-分页列表
  auditStrategyPage: `${prefix}/auditStrategy/page`,
  // 审核策略管理-校验名称是否可用
  auditStrategyUnique: `${prefix}/auditStrategy/unique`,
  // 审核策略管理-修改审核策略名称
  auditStrategyName: `${prefix}/auditStrategy/name`,
  // 审核策略管理-修改文本审核场景
  auditStrategySceneText: `${prefix}/auditStrategy/scene/text`,
  // 审核策略管理-修改图片审核场景
  auditStrategyScenePicture: `${prefix}/auditStrategy/scene/picture`,
  // 审核策略管理-开启
  auditStrategyOpen: `${prefix}/auditStrategy/open`,
  // 审核策略管理-关闭
  auditStrategyClose: `${prefix}/auditStrategy/close`,
  // 审核策略管理-删除或创建
  auditStrategy: `${prefix}/auditStrategy`,
  // 审核栏目设置-审核栏目设置
  auditchannelsetList: `${prefix}/auditchannelset/list`,
  // 审核栏目设置-强制通过
  auditchannelsetPass: `${prefix}/auditchannelset/pass`,
  // 审核栏目设置-强制不通过
  auditchannelsetNopass: `${prefix}/auditchannelset/nopass`,
  // 审核栏目设置-开启状态
  auditchannelsetOn: `${prefix}/auditchannelset/on`,
  // 审核栏目设置-开启状态
  auditchannelsetOff: `${prefix}/auditchannelset/off`,
  // 审核栏目设置-删除栏目设置/选择栏目详情/保存选择栏目
  auditchannelset: `${prefix}/auditchannelset`,
  // 审核模型设置-内容模型设置列表
  auditmodelsetList: `${prefix}/auditmodelset/list`,
  // 审核模型设置-选择内容模型下拉列表
  auditmodelsetModels: `${prefix}/auditmodelset/models`,
  // 审核模型设置-删除模型设置/模型设置获取详情/ 添加/修改模型设置
  auditmodelset: `${prefix}/auditmodelset`,
  // 审核模型设置-选择内容模型ID查询字段
  auditmodelsetItems: `${prefix}/auditmodelset/items`
}
